import { useEmployeePlannerAbsence } from '../../hooks/useEmployeePlannerAbsence';
import { DialogUI } from '../Interface';
import { useEffect, useState } from 'react';
import { EmployeePlannerAbsencePage } from './EmployeePlannerAbsencePage';

const EmployeePlannerDialog = ({ open, handleClose, changed, data }) => {
  const { dataChanged, setDataChanged } = changed;
  const employeePlanAbsenceState = useEmployeePlannerAbsence();
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    if (data) {
      employeePlanAbsenceState.setSelectedValues(data);
      setIsUpdate(true);
    }
  }, [data, employeePlanAbsenceState]);

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent={data ? 'Szabadság módosítása' : 'Új szabadság létrehozása'}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <div className="mt-5">
        <EmployeePlannerAbsencePage
          dialog={{
            handleClose: handleClose,
            dataChanged: dataChanged,
            setDataChanged: setDataChanged,
            isUpdate: isUpdate,
          }}
          employeePlanAbsenceState={employeePlanAbsenceState}
        />
      </div>
    </DialogUI>
  );
};

export default EmployeePlannerDialog;
